import { Label } from "../ui/label";
import { RadioGroupItem } from "../ui/radio-group";

type RadioWithLabelProps = {
    label: string;
    value: string;
};

const RadioWithLabel = ({ label, value }: RadioWithLabelProps) => (
    <div className="flex flex-1 items-center space-x-2 rounded-md border p-2">
        <RadioGroupItem id={value} value={value} />
        <Label className="w-full" htmlFor={value}>
            {label}
        </Label>
    </div>
);

export default RadioWithLabel;
